import type { RosterEntry } from '@nostos/shared';
import type { RosterRepository } from './Repository.js';
import { localDb } from './dexieDb.js';

/** Dexie/IndexedDB implementation of the roster seam. */
export class DexieRosterRepository implements RosterRepository {
  list(): Promise<RosterEntry[]> {
    return localDb.roster.toArray();
  }

  get(id: string): Promise<RosterEntry | undefined> {
    return localDb.roster.get(id);
  }

  getByToken(token: string): Promise<RosterEntry | undefined> {
    return localDb.roster.where('token').equals(token).first();
  }

  async upsert(entry: RosterEntry): Promise<void> {
    await localDb.roster.put(entry);
  }

  async remove(id: string): Promise<void> {
    await localDb.roster.delete(id);
  }

  async clear(): Promise<void> {
    await localDb.roster.clear();
  }
}
